/**
 * Synced from convex/lib/inferSourceDate.ts (FEAT-885: shared date inference, BR-108: MCP import boundary).
 */

/**
 * Infer an ISO date (YYYY-MM-DD) from free-text values.
 *
 * Canonical source for MCP (packages/mcp-server/src/lib/inferSourceDate.ts)
 * and CLI (packages/cli/src/lib/inferSourceDate.ts) — both are synced copies
 * maintained by scripts/sync-convex-lib-to-mcp.mjs (FEAT-885, BR-108).
 */

export function inferSourceDate(...values: Array<string | undefined>): string | undefined {
	const combined = values
		.filter((value): value is string => typeof value === 'string' && value.trim().length > 0)
		.join('\n');

	if (!combined) return undefined;

	const isoMatch = combined.match(/\b(20\d{2}-\d{2}-\d{2})\b/);
	if (isoMatch) return isoMatch[1];

	const monthMatch = combined.match(
		/\b(january|february|march|april|may|june|july|august|september|october|november|december)\s+(\d{1,2})(?:st|nd|rd|th)?(?:,?\s+(20\d{2}))?\b/i,
	);
	if (!monthMatch) return undefined;

	const monthIndex = [
		'january',
		'february',
		'march',
		'april',
		'may',
		'june',
		'july',
		'august',
		'september',
		'october',
		'november',
		'december',
	].indexOf(monthMatch[1].toLowerCase());
	if (monthIndex < 0) return undefined;

	const inferredYear = monthMatch[3] ?? combined.match(/\b(20\d{2})\b/)?.[1] ?? String(new Date().getUTCFullYear());
	const month = String(monthIndex + 1).padStart(2, '0');
	const day = monthMatch[2].padStart(2, '0');
	return `${inferredYear}-${month}-${day}`;
}
